import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import ModalFooter from '../ModalFooter';
import i18n from '../../utils/i18n';

import styles from './styles.scss';

export default function OrderHelpTemplateEmptyState({
  data,
  iframe,
  hideFooterPrevious,
  finishInteraction,
}) {
  const onButtonClick = () => {
    if (data.buttonType === 'go_back') {
      /* exit modal */
      finishInteraction();
    } else {
      /* refresh page */
      window.location.reload();
    }
  };
  return (
    <div className={classnames({ [styles['empty-state']]: !iframe })}>
      <Spacer spacing={iframe ? '0 x-large' : '0 medium'}>
        <div className={classnames({ [styles['empty-state-text-wrapper']]: !iframe })}>
          <Heading level={2} size="x-small">
            {data.title || i18n.gettext('order_help.error_loading_shs.heading')}
          </Heading>
        </div>
        <div className={classnames({ [styles['empty-state-text-wrapper']]: !iframe })}>
          <P>{data.message || i18n.gettext('order_help.error_loading_shs.text')}</P>
        </div>
      </Spacer>
      <ModalFooter
        modal={iframe}
        onSubmit={onButtonClick}
        cta={data.buttonText || i18n.gettext('order_help.error_loading_shs.retry_button')}
        hidePrevious={hideFooterPrevious}
      />
    </div>
  );
}

OrderHelpTemplateEmptyState.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    button: PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.string,
    }),
  }),
  iframe: PropTypes.bool,
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  finishInteraction: PropTypes.func.isRequired,
};

OrderHelpTemplateEmptyState.defaultProps = {
  data: {},
  iframe: false,
  hideFooterPrevious: true,
};
